import React from "react";
import Template from "../Generico/Template";
import TituloPrincipal from "../Generico/TituloPrincipal";
import { Box } from "@mui/material";
import ConfigurarTema from "./configurarTema";
import OutrasConfiguracoes from "./outrasConfiguracoes";

function Configuracoes() {
  return (
    <Template documentTitle="Configurações gerais">
      <TituloPrincipal
        title="Configurações gerais"
        subTitle="Configure as opções globais do sistema"
      />

      <Box mt="2rem">
        <ConfigurarTema />
      </Box>

      <Box mt="2rem">
        <OutrasConfiguracoes />
      </Box>
    </Template>
  );
}

export default Configuracoes;
